var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 11.2571C3.5805 8.36963 4.00812 6.56837 5.28962 5.28962C6.56837 4.00812 8.36963 3.5805 11.2571 3.4375M29.5625 11.2571C29.4195 8.36963 28.9919 6.56837 27.7104 5.28962C26.4316 4.00812 24.6304 3.5805 21.7429 3.4375M21.7429 29.5625C24.6304 29.4195 26.4316 28.9919 27.7104 27.7104C28.9919 26.4316 29.4195 24.6304 29.5625 21.7429M11.2571 29.5625C8.36963 29.4195 6.56837 28.9919 5.28962 27.7104C4.00812 26.4316 3.5805 24.6304 3.4375 21.7429M26.9981 15.5622C27.3323 15.9802 27.5 16.1906 27.5 16.5C27.5 16.8094 27.3323 17.0198 26.9981 17.4378C25.4953 19.3188 21.6576 23.375 16.5 23.375C11.3424 23.375 7.50475 19.3188 6.00187 17.4378C5.66775 17.0198 5.5 16.8094 5.5 16.5C5.5 16.1906 5.66775 15.9802 6.00187 15.5622C7.50475 13.6812 11.3424 9.625 16.5 9.625C21.6576 9.625 25.4953 13.6812 26.9981 15.5622Z",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.5C19.25 15.7707 18.9603 15.0712 18.4445 14.5555C17.9288 14.0397 17.2293 13.75 16.5 13.75C15.7707 13.75 15.0712 14.0397 14.5555 14.5555C14.0397 15.0712 13.75 15.7707 13.75 16.5C13.75 17.2293 14.0397 17.9288 14.5555 18.4445C15.0712 18.9603 15.7707 19.25 16.5 19.25C17.2293 19.25 17.9288 18.9603 18.4445 18.4445C18.9603 17.9288 19.25 17.2293 19.25 16.5Z",
    stroke: "#741374",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.4e77b33f6c926071d81377e025123ce0.svg";
export { ForwardRef as ReactComponent };